import dashboardReducer from './dashboard'

export default dashboardReducer
